import { NotFoundPage } from '../features/notFound';
import { Routes, Route } from 'react-router-dom';

import { OptimizedRoute, RoutesHistoryPage } from '../features/routes';
import { EnabledRoutes } from '../features/routes/enabled';

import OrdersPage from '../features/orders';
import PrivateRoute from './PrivateRoute';
import ClouderHomeRoute from './ClouderHomeRoute';
import RegionalHubRoutesGuard from './RegionalHubRoutesGuard';
import BankAccountRoutesGuard from './BankAccountRoutesGuard';
import QRScannerViewer from '../features/orders/QRScannerViewer';
import { BankAccountPage } from '../features/user';
import { SemiMonthlySummaryPage } from '../features/semiMonthlySummary';

const ClouderRoutes = () => {
  return (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route index element={<ClouderHomeRoute />} />
        <Route path="orders/dashboard" element={<OrdersPage />} />
        <Route
          path="routes/dashboard"
          element={
            <RegionalHubRoutesGuard>
              <EnabledRoutes />
            </RegionalHubRoutesGuard>
          }
        />
        <Route
          path="routes/history"
          element={
            <RegionalHubRoutesGuard>
              <RoutesHistoryPage />
            </RegionalHubRoutesGuard>
          }
        />
        <Route
          path="routes/optimized"
          element={
            <RegionalHubRoutesGuard>
              <OptimizedRoute />
            </RegionalHubRoutesGuard>
          }
        />
        <Route path="orders/to-receive/scanner" element={<QRScannerViewer />} />
        <Route
          path="profile/bank-account"
          element={
            <BankAccountRoutesGuard>
              <BankAccountPage />
            </BankAccountRoutesGuard>
          }
        />
        <Route
          path="semi-monthly-summary"
          element={
            <RegionalHubRoutesGuard>
              <SemiMonthlySummaryPage />
            </RegionalHubRoutesGuard>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default ClouderRoutes;
